<div
  class="sidenav-container__backdrop"
  [class.sidenav-container__backdrop--visible]="showBackdrop"
  (click)="onBackdropClick()"
></div>
<ng-content select="app-sidenav"></ng-content>
<ng-content select="app-sidenav-content"></ng-content>
